import React from "react"
import {
  Tab as ReactTab,
  Tabs as ReactTabs,
  TabList as ReactTabList,
  TabPanel as ReactTabPanel,
  TabsProps,
} from "react-tabs"
import styled from "styled-components"
import { theme } from "../../util/styles/theme"

export const SELECTED_TAB_CLASSNAME = "selected-tab"

interface TabListProps {
  alignment?: "left" | "center"
}

const StyledTabList = styled(ReactTabList)<TabListProps>`
  display: flex;
  justify-content: ${({ alignment }) => alignment};
  margin: 0 0 ${theme.spacings.xlarge};
  padding: 0;
`

const StyledTab = styled(ReactTab)`
  ${theme.textStyle("default", "medium", "medium")}
  display: block;
  background: ${theme.colors.white};
  color: ${theme.colors.blue};

  &.${SELECTED_TAB_CLASSNAME} {
    background: ${theme.colors.orange};
    color: ${theme.colors.white};
  }

  &:not(.${SELECTED_TAB_CLASSNAME}):hover {
    background: ${theme.colors.greyCold};
    border-color: ${theme.colors.greyCold};
  }
  cursor: pointer;

  padding-top: ${theme.spacings.small};
  padding-bottom: ${theme.spacings.small};
  padding-left: ${theme.spacings.xlarge};
  padding-right: ${theme.spacings.xlarge};

  border-radius: ${theme.borderRadius.medium};

  &.${SELECTED_TAB_CLASSNAME} {
    z-index: 1;
  }

  :first-child {
    border-radius: ${theme.borderRadius.medium} 0 0 ${theme.borderRadius.medium};
    margin-right: -${theme.borderRadius.medium};
    padding-right: calc(
      ${theme.borderRadius.medium} + ${theme.borderRadius.medium}
    );

    &.${SELECTED_TAB_CLASSNAME} {
      border-radius: ${theme.borderRadius.medium};
      padding-right: ${theme.spacings.xlarge};
    }
  }

  :last-child {
    border-radius: 0 ${theme.borderRadius.medium} ${theme.borderRadius.medium} 0;
    padding-left: calc(
      ${theme.borderRadius.medium} + ${theme.borderRadius.medium}
    );

    &.${SELECTED_TAB_CLASSNAME} {
      border-radius: ${theme.borderRadius.medium};
      padding-left: ${theme.spacings.xlarge};
    }
  }
`

export const Tabs: React.FunctionComponent<TabsProps> = props => {
  return <ReactTabs selectedTabClassName={SELECTED_TAB_CLASSNAME} {...props} />
}

export const TabList = StyledTabList

export const Tab = StyledTab

export const TabPanel = ReactTabPanel

TabList.defaultProps = {
  alignment: "center",
}
